import styled, { css } from 'styled-components';

import { FlexCard } from '@ui-library/card';

const defaultStyles = css<{ isSelected?: boolean }>`
  background-color: ${({ theme, isSelected }) =>
    isSelected ? theme.token['blue.2'] : theme.token.colorInfoBg};
  border-color: ${({ theme, isSelected }) =>
    isSelected ? theme.token['blue.6'] : theme.token.colorBorderSecondary};
  &:hover {
    background-color: ${({ theme, isSelected }) =>
      isSelected ? theme.token['blue.2'] : theme.token['blue.1']};
    border-color: ${({ theme }) => theme.token['blue.6']};
    cursor: pointer;
  }
`;

const nextStyles = css<{ isSelected?: boolean }>`
  border-radius: ${({ theme }) => theme.token.next.borderRadius};
  background-color: ${({ theme, isSelected }) =>
    isSelected ? theme.token.next.palette.blue50 : theme.token.next.palette.grey0};
  border-color: ${({ theme, isSelected }) =>
    isSelected ? theme.token.next.colorBorderFocus : theme.token.next.colorBorder};
  box-shadow: ${({ theme, isSelected }) => (isSelected ? theme.token.next.boxShadowFocus : 'none')};
  &:hover {
    background-color: ${({ theme, isSelected }) =>
      isSelected ? theme.token.next.palette.blue50 : theme.token.next.palette.grey0};
    border-color: ${({ theme, isSelected }) =>
      isSelected ? theme.token.next.colorBorderFocus : theme.token.next.colorBorderHover};
    box-shadow: ${({ theme, isSelected }) =>
      isSelected ? theme.token.next.boxShadowFocus : theme.token.next.boxShadowHover};
    cursor: pointer;
  }
`;

export const SelectableCard = styled(FlexCard)<{ isSelected?: boolean; variant?: 'next' }>`
  flex: 0 0 auto;
  ${({ variant }) => (variant ? nextStyles : defaultStyles)}
`;
